// extracted by mini-css-extract-plugin
module.exports = {"item":"ServiceGroupInfo_item__1sqPq","status":"ServiceGroupInfo_status__15GYm","title":"ServiceGroupInfo_title__2quUU","serviceInfo":"ServiceGroupInfo_serviceInfo__3_uHa"};